import { render, staticRenderFns } from "./DgItextPop.vue?vue&type=template&id=1018813c"
import script from "./DgItextPop.vue?vue&type=script&lang=js"
export * from "./DgItextPop.vue?vue&type=script&lang=js"
import style0 from "./DgItextPop.vue?vue&type=style&index=0&id=1018813c&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1018813c')) {
      api.createRecord('1018813c', component.options)
    } else {
      api.reload('1018813c', component.options)
    }
    module.hot.accept("./DgItextPop.vue?vue&type=template&id=1018813c", function () {
      api.rerender('1018813c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/pdf/popup/DgItextPop.vue"
export default component.exports